<template>
    <div
        class="ep"
        role="progressbar"
        :aria-label="rotuloAcessivel"
        :aria-valuenow="indice + 1"
        :aria-valuemin="1"
        :aria-valuemax="etapas.length"
    >
        <div v-if="!mostraTodosRotulos && grupoAtual.nome" class="ep__rotulo ep__rotulo--solo">
            {{ grupoAtual.nome }}
        </div>

        <div class="ep__faixa">
            <div
                v-for="(grupo, i) in grupos"
                :key="i"
                class="ep__grupo"
                :class="{ 'ep__grupo--ativo': i === indiceDoGrupoAtual }"
                :style="{ flexGrow: grupo.etapas }"
            >
                <div v-if="mostraTodosRotulos && grupo.nome" class="ep__rotulo" :title="grupo.nome">
                    {{ grupo.nome }}
                </div>

                <div class="ep__segs">
                    <span
                        v-for="n in grupo.etapas"
                        :key="n"
                        class="ep__seg"
                        :class="classeDoSegmento(grupo.inicio + n - 1)"
                    ></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'EtapaProgresso',

    props: {
        etapas: { type: Array, required: true },
        indice: { type: Number, default: 0 },
    },

    computed: {
        grupos() {
            const grupos = [];

            this.etapas.forEach((etapa, i) => {
                const ultimo = grupos[grupos.length - 1];
                const nome = etapa.contexto || '';

                if (ultimo && ultimo.nome === nome) {
                    ultimo.etapas++;
                    return;
                }

                grupos.push({ nome, inicio: i, etapas: 1 });
            });

            return grupos;
        },

        indiceDoGrupoAtual() {
            return this.grupos.findIndex(g => this.indice >= g.inicio && this.indice < g.inicio + g.etapas);
        },

        grupoAtual() {
            return this.grupos[this.indiceDoGrupoAtual] || { nome: '' };
        },

        mostraTodosRotulos() {
            return this.grupos.length <= 3;
        },

        rotuloAcessivel() {
            const posicao = this.$t('etapa.progresso', { atual: this.indice + 1, total: this.etapas.length });

            return this.grupoAtual.nome ? `${posicao}, ${this.grupoAtual.nome}` : posicao;
        },
    },

    methods: {
        classeDoSegmento(i) {
            if (i < this.indice) return 'ep__seg--feito';

            return i === this.indice ? 'ep__seg--agora' : '';
        },
    },
};
</script>

<style scoped>
.ep {
    display: flex;
    flex-direction: column;
    gap: 3px;
    padding: 9px 12px 10px;
}

.ep__faixa { display: flex; gap: 10px; }

.ep__grupo { flex-basis: 0; min-width: 0; }

.ep__rotulo {
    font-size: 9px;
    font-weight: 800;
    letter-spacing: .08em;
    text-transform: uppercase;
    line-height: 1.5;
    color: #8b9098;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.ep__grupo--ativo > .ep__rotulo,
.ep__rotulo--solo { color: inherit; }

.ep__segs { display: flex; gap: 2px; align-items: center; height: 8px; }

.ep__seg {
    flex: 1;
    min-width: 2px;
    height: 4px;
    border-radius: 4px;
    background: rgba(128, 128, 128, .28);
    transition: height .18s ease, background .18s ease;
}
.ep__seg--feito { background: #0f8a3d; }

.ep__seg--agora { height: 8px; background: var(--v-primary-base); }

@media (prefers-reduced-motion: reduce) {
    .ep__seg { transition: none; }
}
</style>
